/**
 * @generated SignedSource<<3c294884c259f794e381a8d05bc88c0c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteRuleInputObject = {
  ruleId: string;
};
export type rulesPage_DeleteRuleMutation$variables = {
  input: DeleteRuleInputObject;
};
export type rulesPage_DeleteRuleMutation$data = {
  readonly deleteRule: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly rule: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type rulesPage_DeleteRuleMutation = {
  response: rulesPage_DeleteRuleMutation$data;
  variables: rulesPage_DeleteRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Rule",
  "kind": "LinkedField",
  "name": "rule",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "rulesPage_DeleteRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteRuleMutationPayload",
        "kind": "LinkedField",
        "name": "deleteRule",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rulesPage_DeleteRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteRuleMutationPayload",
        "kind": "LinkedField",
        "name": "deleteRule",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "73517ee56f8503fc16652f70d8e35478",
    "id": null,
    "metadata": {},
    "name": "rulesPage_DeleteRuleMutation",
    "operationKind": "mutation",
    "text": "mutation rulesPage_DeleteRuleMutation(\n  $input: DeleteRuleInputObject!\n) {\n  deleteRule(input: $input) {\n    rule {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2424f486ba953d7910823d6bd22b4aea";

export default node;
